// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Abladestelle } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetAbladestelle(): (id: string) => Promise<Abladestelle> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).abladestellen.getAbladestelle({ id }),
    [getAPI]
  );
}
